import { render, staticRenderFns } from "./shared_title.vue?vue&type=template&id=b63191d2&"
import script from "./shared_title.vue?vue&type=script&lang=js&"
export * from "./shared_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b63191d2')) {
      api.createRecord('b63191d2', component.options)
    } else {
      api.reload('b63191d2', component.options)
    }
    module.hot.accept("./shared_title.vue?vue&type=template&id=b63191d2&", function () {
      api.rerender('b63191d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/auth/shared_title.vue"
export default component.exports